import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
/**
 * Extracts book club terms and conditions from the item relation on the shape.
 * This is separate from series subscription variant terms.
 *
 * Book club terms are stored as an item relation with identifier "vilkar-og-forpliktelser"
 * on the book club shape level (not variant level).
 */
export const getBookClubTermsConditions = (subscription) => {
    const termsRelationComponent = subscription.product?.components?.find(({ componentId }) => componentId ===
        CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.TERMS_AND_CONDITIONS.ID);
    if (!termsRelationComponent?.content)
        return undefined;
    if (termsRelationComponent.content.__typename !== "ItemRelationsContent")
        return undefined;
    const termsItem = termsRelationComponent.content.items?.[0];
    if (!termsItem?.components?.length)
        return undefined;
    const termsComponent = termsItem.components.find(({ componentId }) => componentId ===
        CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.TERMS_AND_CONDITIONS.TERMS);
    if (!termsComponent?.content)
        return undefined;
    if (termsComponent.content.__typename !== "RichTextContent")
        return undefined;
    return termsComponent.content.html;
};
